import { render, staticRenderFns } from "./CheckboxCard.vue?vue&type=template&id=e8d49f1a&scoped=true"
import script from "./CheckboxCard.vue?vue&type=script&lang=js"
export * from "./CheckboxCard.vue?vue&type=script&lang=js"
import style0 from "./CheckboxCard.vue?vue&type=style&index=0&id=e8d49f1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d49f1a",
  null
  
)

export default component.exports